import { clsx } from 'clsx';
import { CSSProperties } from 'react';
import useDataTestId from '~/hooks/useDataTestId';
import styles from './SkeletonLoader.module.scss';

interface SkeletonLoaderProps {
  style?: CSSProperties;
  className?: string;
  dataTestId?: string;
  height?: number | string;
  width?: number | string;
  count?: number;
}

export const SkeletonLoader = ({
  className,
  style,
  dataTestId,
  height = 16,
  width,
  count = 1,
}: SkeletonLoaderProps) => {
  const dt = useDataTestId(dataTestId);
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={clsx(styles.skeletonContent, className)}
          style={{ ...style, height, width }}
          data-testid={dt()}
        />
      ))}
    </>
  );
};
